import { styled } from '@mui/material';

import { LoginForm } from '@app-velocity/modules/users';

import { Banner } from './components/Banner';
import { PromoText } from './components/PromoText';

const AuthenticationPageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  justifyContent: 'flex-end',
  height: '100vh',
});

const FormContainer = styled('div')(({ theme }) => ({
  borderTopRightRadius: theme.spacing(2),
  borderTopLeftRadius: theme.spacing(2),
  padding: theme.spacing(5),
  marginTop: theme.spacing(-2),
  background: '#fff',
  zIndex: 2,
}));

export const AuthenticationPage = () => {
  return (
    <AuthenticationPageContainer>
      <Banner />
      <PromoText />
      <FormContainer>
        <LoginForm />
      </FormContainer>
    </AuthenticationPageContainer>
  );
};
